/**
 * @generated SignedSource<<45a0a2c125c1404824bf1444d4c644f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateAnswerInput = {
  answerId: string;
  clientMutationId?: string | null;
  exclusive?: boolean | null;
  quota?: number | null;
  rating?: number | null;
  terminate?: boolean | null;
  terminateCondition?: any | null;
  text?: string | null;
  userSpecified?: boolean | null;
};
export type GridQuestionEditor_updateColumn_Mutation$variables = {
  input: UpdateAnswerInput;
};
export type GridQuestionEditor_updateColumn_Mutation$data = {
  readonly updateAnswer: {
    readonly answer: {
      readonly id: string;
      readonly terminate: boolean;
      readonly text: string | null;
    } | null;
    readonly element: {
      readonly answers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly terminate: boolean;
          } | null;
        } | null>;
      };
      readonly gridAnswers: ReadonlyArray<{
        readonly answer: {
          readonly id: string;
        };
        readonly goal: number | null;
        readonly row: {
          readonly id: string;
        };
        readonly terminate: boolean | null;
      } | null> | null;
      readonly rows: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};
export type GridQuestionEditor_updateColumn_Mutation = {
  response: GridQuestionEditor_updateColumn_Mutation$data;
  variables: GridQuestionEditor_updateColumn_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerNode",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerNodeConnection",
  "kind": "LinkedField",
  "name": "answers",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AnswerNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v2/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "RowNodeConnection",
  "kind": "LinkedField",
  "name": "rows",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RowNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RowNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "RowNode",
  "kind": "LinkedField",
  "name": "row",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerNode",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "goal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GridQuestionEditor_updateColumn_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAnswerPayload",
        "kind": "LinkedField",
        "name": "updateAnswer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementNode",
            "kind": "LinkedField",
            "name": "element",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GridAnswerNode",
                "kind": "LinkedField",
                "name": "gridAnswers",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GridQuestionEditor_updateColumn_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAnswerPayload",
        "kind": "LinkedField",
        "name": "updateAnswer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementNode",
            "kind": "LinkedField",
            "name": "element",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GridAnswerNode",
                "kind": "LinkedField",
                "name": "gridAnswers",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "458a26cd09eac2adf13dba9834d34b80",
    "id": null,
    "metadata": {},
    "name": "GridQuestionEditor_updateColumn_Mutation",
    "operationKind": "mutation",
    "text": "mutation GridQuestionEditor_updateColumn_Mutation(\n  $input: UpdateAnswerInput!\n) {\n  updateAnswer(input: $input) {\n    answer {\n      id\n      terminate\n      text\n    }\n    element {\n      answers {\n        edges {\n          node {\n            id\n            terminate\n          }\n        }\n      }\n      rows {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      gridAnswers {\n        row {\n          id\n        }\n        answer {\n          id\n        }\n        goal\n        terminate\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "75781fc0f26af948d33b41d5afc5da69";

export default node;
